<template>
  <va-card>
    <vue-element-loading :active="visible" :is-full-screen="true" />
    <h4 style="font-size: 24px !important" class="text-uppercase">
      Editing images in Digital Guide
    </h4>
    <br />

    <b-row class="py-3">
      <b-col cols="12" md="12">
        <span class="poppinsregular" style="font-size: 14px">
          Upload Map Image</span
        >
      </b-col>
      <b-col cols="12" md="6" class="pt-3">
        <output>
          <img
            :src="previewUrl"
            v-if="previewUrl"
            style="width: 150px; height: 150px; object-fit: contain"
          />
        </output>
        <input
          type="file"
          id="file"
          accept="image/*"
          v-on:change="uploadImage($event)"
        />
      </b-col>
      <b-col cols="12" md="6" class="pt-3">
        <div class="formgroup">
          <span class="poppinsregular" style="font-size: 14px">
            Copyright Information</span
          >
          <input
            v-model="mapCopyright"
            type="text"
            required
            class="poppinsregular pa-2 form-control"
            placeholder="Copyright for Map"
            style="
              font-size: 14px;
              color: black !important;
              width: 100% !important;
            "
          />
        </div>
      </b-col>
      <b-col class="pt-2">
        <b-button size="sm" @click="mapImageUpload" variant="success">
          submit
        </b-button>
      </b-col>
    </b-row>
    <hr />
    <div class="pb-5">
      <div class="card-header">Adding images to Digital Guide</div>
      <div
        id="my-strictly-unique-vue-upload-multiple-image"
        style="display: flex; justify-content: center"
      >
        <vue-upload-multiple-image
          @upload-success="uploadImageSuccess"
          @limit-exceeded="imageLimit"
          :data-images="images"
          drag-text="Drag pictures"
          browse-text="Browse picture(s)"
          mark-is-primary-text="Set as default"
          popup-text="This image will be displayed as default"
          :show-edit="false"
          :show-delete="false"
          :maxImage="4"
        ></vue-upload-multiple-image>
      </div>
    </div>
    <!-- <div v-if="photos.length > 0" class="card" style="width: 100%">
      <div class="card-header">
        Delete Photos
        <span>
          <button
            type="button"
            @click="deletePhoto"
            class="btn btn-secondary"
            style="padding-top:0px!important;padding-bottom:0px!important;padding-left:10px!important;padding-right:10px!important;font-size:14px;!important;"
          >
            <va-icon
              style="font-size:14px;!important;"
              name="fa fa-trash"
            />&nbsp;Delete
          </button>
        </span>
      </div>

      <div class="flex md12 xs6 sm12 pt-2 pb-2">
        <vue-select-image
          :dataImages="dataImages"
          h="80px"
          w="auto"
          :is-multiple="true"
          @onselectmultipleimage="onSelectImage2"
          style="padding-left: 0px"
        ></vue-select-image>
      </div>
      <div class="card-header">
        (Please select image and click on the Delete button )
        <b-button variant="danger" @click="deleteCType(data.item._id)"
          >Delete</b-button
        >
      </div>
    </div> -->
    <b-card>
      <b-row class="pa-2">
        <b-col cols="4"> <span class="text-bo">Delete Photos</span> </b-col>
        <b-col cols="8" class="text-right">
          (Please select image and click on the Delete button )
          <b-button variant="danger" @click.prevent="confirmRemovePhotos()"
            >Delete</b-button
          >
        </b-col>
      </b-row>
      <div class="overflow-aut0" style="overflow: auto">
        <b-table
          style="padding: 40px"
          hover
          v-if="photos.length"
          id="my-table"
          :fields="fields"
          :items="photos"
          small
          borderless
          head-variant="light"
          table-variant="light"
        >
          <template v-slot:cell(selected)="data">
            <b-form-group>
              <input
                type="checkbox"
                :value="data.item.fileName"
                v-model="deleteIds"
              />
            </b-form-group>
          </template>
          <template v-slot:cell(fileName)="data1" style="text-align: center">
            <img
              v-if="data1.item.fileName != ''"
              v-bind:src="baseURL + data1.item.fileName"
              width="50px"
              height="50px"
            />
            <p v-else>No Image</p>
          </template>
          <template v-slot:cell(copyright)="data">
            <b-form-input
              style="text-align: center"
              borderless="true"
              v-model="data.item.copyright"
            />
          </template>
          <template v-slot:cell(_id)="data">
            <span style="padding-left: 20px !important">
              <!-- <router-link :to="'/editwlpa/'+data.item._id ">
                    <b-button type="submit" variant="info">Update</b-button>
                  </router-link> -->
              <b-button  @click="updateCopyright(data.item)" variant="info"
                >Update</b-button
              >
            </span>
            <!-- <span style="padding-left: 20px !important">
            <b-button variant="danger" @click="deleteCType(data.item._id)"
              >Delete</b-button
            >
          </span> -->
          </template>
        </b-table>
        <p v-else>No Data Found</p>
      </div>
    </b-card>
    <br />
    <p align="center">
      <b-button
        type="button"
        pill
        v-on:click="aler"
        class="btn btn-secondary rad1"
        style="padding-left: 30px; padding-right: 30px !important"
      >
        <b>NEXT</b>
      </b-button>
      <br />
      <b-modal
        size="md"
        id="modal-uploadImageCopyright"
        centered
        :hide-backdrop="false"
        hide-footer
        hide-header
      >
        <!-- <p class="poppinsbold" style="font-size: 18px">
            NOTIFY THE TEAM MEMBER
          </p> -->
        <div class="pb-3">
          <label style="font-size: 14px" class="poppinsregular">
            Please Enter Copyright message
            <sup>*</sup>
          </label>
          <div class="formgroup">
            <input
              v-model="copyrightData.copyright"
              type="text"
              required
              class="poppinsregular pa-2 form-control"
              placeholder="Copyright Message"
              style="
                font-size: 14px;
                color: black !important;
                width: 100% !important;
              "
            />
          </div>
        </div>

        <b-button
          variant="success"
          @click="validate"
          size="sm"
          class="px-2"
          type="submit"
          >SUBMIT</b-button
        >
      </b-modal>
    </p>
  </va-card>
</template>
<script>
import axios from "axios";
import VueElementLoading from "vue-element-loading";
import VueUploadMultipleImage from "vue-upload-multiple-image";
export default {
  props: ["id"],
  components: {
    VueElementLoading,
    VueUploadMultipleImage,
  },
  data() {
    return {
      visible: false,
      img: 0,
      count: 0,
      images: [],
      mageDisplay: [],
      deleteId: [],
      photos: [],
      msg: "",
      dataImages: [],
      err: "",
      previewUrl: "",
      selectedFile: null,
      url: null,

      copyrightData: {
        fileName: null,
        copyright: null,
      },
      mapImage: null,
      mapCopyright: null,
      deleteIds: [],
      fields: [
        { key: "selected", label: "Action", tdClass: "cnt", thClass: "cnt" },

        {
          label: "Copyright Message",
          key: "copyright",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt text-uppercase",
        },
        {
          label: "Image",
          key: "fileName",
          sortable: false,
          tdClass: "cnt",
          thClass: "cnt",
        },

        {
          label: " Action",
          key: "_id",
          sortable: false,
          thClass: "cnt",
          tdClass: "cnt",
        },
      ],
    };
  },
  mounted: function () {
    this.photoView();
  },
  methods: {
    uploadImage(event) {
      this.mapImage = event.target.files[0];
      // this.url = URL.createObjectURL(this.mapImage);
      const file = event.target.files[0];
      if (file) {
        this.stat = 1;
      } else {
        this.stat = 0;
        return false;
      }
      if (!file.type.match("image.*")) {
        // return false
        this.stat = 0;
      } else {
        this.stat = 1;
      }
      const reader = new FileReader();
      const that = this;
      reader.onload = function (e) {
        that.previewUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    aler() {
      this.msg = "Record Details edited successfully";
      this.$dlg.alert(
        this.msg,
        () => {
          this.$router.push({ name: "listRecords" });
        },
        { messageType: "success" }
      );
    },
    onSelectImage2(event) {
      this.imageDisplay = event.src;
      this.deleteId = [];
      for (var i = 0; i < event.length; i++) {
        this.deleteId.push(event[i].id);
      }
    },
    validate() {
      if (this.copyrightData&&!this.copyrightData.copyright) {
        this.$dlg.alert(
          "Please Provide data",
          () => {
            // this.$router.push({ name: "listRecords" });
          },
          { messageType: "success" }
        );
      } else {
        this.updateCopyright(this.copyrightData);
      }
    },
    updateCopyright(item) {
      this.visible = true;
      // evt.preventDefault();
      var data1 = {};
      data1["id"] = this.id;
      data1["copyright"] = item.copyright;
      data1["key"] = item.fileName;
      axios({
        method: "POST",
        url: "/digitalguide/photos/copyright/add",
        data: data1,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.visible = false;
          if (response.data.status === true) {
            // this.$router.push({ name: "myprofile" });
            this.$bvModal.hide("modal-uploadImageCopyright");
            this.photoView();
          } else {
            this.$dlg.alert(
              this.msg,
              () => {
                window.location.reload();
              },
              { messageType: "error" }
            );
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data.status === false) {
            this.msg = "Please Try Again";
          }
        });
    },

    mapImageUpload() {
      if (this.mapImage) {
        let formData = new FormData();
        formData.append("mapImage", this.mapImage);
        formData.append("copyright", this.mapCopyright);

        formData.append("id", this.id);
        this.visible = true;
        axios({
          method: "post",
          url: "/digitalguide/upload/mapImage",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
            token: localStorage.getItem("token"),
          },
        })
          .then((response) => {
            if (response.data.status === true) {
              this.visible = false;

              this.$bvToast.toast(response.data.msg, {
                title: `New Message`,
                variant: "success",
                solid: true,
              });
            } else {
              this.visible = false;

              this.$bvToast.toast(response.data.msg, {
                title: `New Message`,
                variant: "danger",
                solid: true,
              });
            }
          })

          .catch((e) => {
            this.visible = false;
          });
      } else {
        this.$bvToast.toast(this.msg, {
          title: `New Message`,
          variant: "please upload map image",
          solid: true,
        });
      }
    },
    photoView() {
      this.visible = true;
      axios({
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        url: "/digitalguide/view/" + this.id,
      }).then((response) => {
        this.visible = false;
        var guideData = {};
        guideData = response.data.data;
        this.photos = response.data.data.photosDetails;
        for (var j = 0; j < this.photos.length; j++) {
          this.photos[j].Selected = false;
        }
        if (guideData.mapImage_copyright) {
          this.mapCopyright = guideData.mapImage_copyright;
        }
        if (guideData.mapImage) {
          this.previewUrl = this.baseURL + guideData.mapImage;
        }

        var tempflag = [];
        for (var i = 0; i < this.photos.length; i++) {
          var tyimg = {
            src: this.baseURL + this.photos[i].fileName,
            id: this.photos[i].fileName,
          };
          tempflag.push(tyimg);
        }
        this.dataImages = tempflag;
      });
    },
    imguplderr(resp) {
      console.log(resp);
    },
    imageLimit() {
      this.msg = "Upload Limit exceeded Please Select max 4 images";
      this.$dlg.alert(
        this.msg,
        () => {
          // this.$router.push("/Dashboard");
        },
        { messageType: "error" }
      );
    },
    uploadImageSuccess(formData, index, fileList) {
      console.log("data", formData, index, fileList);
      formData.append("id", this.id);
      this.visible = true;
      axios({
        method: "POST",
        url: "/digitalguide/upload/photo/" + this.id,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.msg = " image upload success";
            this.copyrightData.fileName = response.data.photos[0];
            this.$bvModal.show("modal-uploadImageCopyright");
            this.$bvToast.toast(this.msg, {
              title: `New Message`,
              variant: "success",
              solid: true,
            });
            this.visible = false;
            this.photoView();
            // this.$dlg.alert(
            //   this.msg,
            //   () => {
            //     window.location.reload()
            //   },
            //   { messageType: 'success' }
            // )
          } else {
            this.msg = "Something Went Wrong";
            this.$bvToast.toast(this.msg, {
              title: `New Message`,
              variant: "danger",
              solid: true,
            });
            this.visible = false;
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          }
        })
        .catch((e) => {
          this.msg = "something went wrong";
          // this.$dlg.alert(
          //   this.msg,
          //   () => {
          //     this.$router.push({ name: "listRecords" });
          //   },
          //   { messageType: "error" }
          // );
        });
    },
    confirmRemovePhotos() {
      if (this.deleteIds.length >= 1) {
        this.$bvModal
          .msgBoxConfirm(
            "Please confirm that you want to Remove the " +
              this.deleteIds.length +
              " Photo(s).",
            {
              title: "Please Confirm",
              size: "md",
              buttonSize: "sm",
              okVariant: "danger",
              cancelVariant: "primary",
              okTitle: "YES",
              cancelTitle: "NO",
              footerClass: "p-2",
              hideHeaderClose: false,
              centered: true,
            }
          )
          .then((value) => {
            if (value) {
              this.deletePhotos();
            }
          })
          .catch((err) => {
            // An error occurred
          });
      } else if (this.deleteIds.length == 0) {
        this.$bvModal.msgBoxOk("Please Select a Photo", {
          title: "Please Select",
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "OK",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        });
      }
    },
    deletePhotos(item) {
      this.visible = true;
      var delphotokey = {};
      delphotokey["key"] = this.deleteIds;
      delphotokey["id"] = this.id;
      axios({
        method: "POST",
        url: "/digitalguide/photos/delete",
        data: delphotokey,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response1) => {
          if (response1.data.status) {
            this.visible = false;
            this.deleteIds = [];
            this.msg = response1.data.msg;
            this.$dlg.alert(
              this.msg,
              () => {
                this.photoView();
              },
              { messageType: "success" }
            );
          } else {
            // this.visible = false;
            // window.location.reload();
            this.msg = response1.data.msg;
            this.$dlg.alert(
              this.msg,
              () => {
                // this.$router.push("/Dashboard");
              },
              { messageType: "error" }
            );
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
  },
};
</script>
<style scoped>
#my-strictly-unique-vue-upload-multiple-image {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.card {
  box-shadow: 0px 0px 0px 0px #707070 !important;
}
</style>
